import React from 'react'
import { Link as BaseLink } from 'react-router-dom'
import { Grid as BaseGrid, styled, Typography } from '@mui/material'
import { ExpandMoreOutlined as BaseExpandMoreIcon, PersonOutlined as BasePersonIcon } from '@mui/icons-material'

export const Root = styled('div')`
  display: block;
  height: auto;
  position: relative;
  width: 100%;
`

export const Row = styled(({ margin, padding, ...props }) => <BaseGrid {...props} container />)`
  &.MuiGrid-container {
    margin: ${props => props.margin || 0};
    padding: ${props => props.padding || 0};
    width: 100%;
  }
`

export const Column = styled(({ margin, padding, ...props }) => <BaseGrid {...props} item />)`
  &.MuiGrid-item {
    margin: ${props => props.margin || 0};
    padding: ${props => props.padding || 0};
    width: 100%;
  }
`

export const LogoLink = styled(BaseLink)`
  margin: 0;
`

export const Logo = styled(({ ...props }) => <img {...props} />)`
  height: 42px;
  pointer-events: none;
  user-select: none;
  ${props => props.theme.breakpoints.up('md')} {
    margin: 0 26px 0 0;
  }
`

export const Link = styled(BaseLink)`
  color: ${props => props.theme.palette.brand.primary};
  font-size: 15px;
  line-height: 22px;
  margin: 0;
  ${props => props.theme.breakpoints.down('md')} {
    display: none;
  }
`

export const User = styled('div')`
  align-items: center;
  display: flex;
  justify-content: end;
  ${props => props.theme.breakpoints.down('sm')} {
    justify-content: start;
    margin-top: 16px;
  }
`

export const PersonIcon = styled(BasePersonIcon)`
  color: ${props => props.theme.palette.brand.primary};
  height: 24px;
  width: 24px;
`

export const UserName = styled(({ ...props }) => <Typography {...props} />)`
  color: ${props => props.theme.palette.brand.black3};
  cursor: pointer;
  font-size: 14px;
  margin: 0 12px;

  ${props => props.theme.breakpoints.down('sm')} {
    margin: 10px 12px;
  }
`

export const ChevronIconDown = styled(({ isOpen, ...props }) => <BaseExpandMoreIcon {...props} />)`
  color: ${props => props.theme.palette.brand.primary};
  cursor: pointer;
  height: 24px;
  width: 24px;
  transform: ${props => (props.isOpen ? 'rotate(-180deg)' : 'none')};
  transition: transform 200ms;
  ${props => props.theme.breakpoints.down('sm')} {
    margin-left: auto;
  }
`
